import classnames from 'classnames';
import { MAIN_PACKAGE_NAME } from '../../constants';

/**
 * Generate a classNames for entry component based on props
 * @param {string} className
 * @param {object} params
 * @returns {string}
 */
export const getPackageEntryClassNames = (className = '') => classnames(MAIN_PACKAGE_NAME, className);
